/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_WaitingInputs */

const en_delivery_board_waiting = /** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for new orders to come in...`)
};

const es_delivery_board_waiting = /** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperando que lleguen nuevos pedidos...`)
};

const fr_delivery_board_waiting = /** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente de nouvelles commandes...`)
};

const de_delivery_board_waiting = /** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warten auf neue Bestellungen...`)
};

const id_delivery_board_waiting = /** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu pesanan baru masuk...`)
};

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const ja_delivery_board_waiting = en_delivery_board_waiting;

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const zh_delivery_board_waiting = en_delivery_board_waiting;

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const ar_delivery_board_waiting = en_delivery_board_waiting;

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const it_delivery_board_waiting = en_delivery_board_waiting;

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const ru_delivery_board_waiting = en_delivery_board_waiting;

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const pt_delivery_board_waiting = en_delivery_board_waiting;

/** @type {(inputs: Delivery_Board_WaitingInputs) => LocalizedString} */
const ko_delivery_board_waiting = en_delivery_board_waiting;

/**
* | output |
* | --- |
* | "Waiting for new orders to come in..." |
*
* @param {Delivery_Board_WaitingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_waiting = /** @type {((inputs?: Delivery_Board_WaitingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_WaitingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_waiting(inputs)
	if (locale === "es") return es_delivery_board_waiting(inputs)
	if (locale === "fr") return fr_delivery_board_waiting(inputs)
	if (locale === "de") return de_delivery_board_waiting(inputs)
	if (locale === "ja") return ja_delivery_board_waiting(inputs)
	if (locale === "zh") return zh_delivery_board_waiting(inputs)
	if (locale === "ar") return ar_delivery_board_waiting(inputs)
	if (locale === "id") return id_delivery_board_waiting(inputs)
	if (locale === "it") return it_delivery_board_waiting(inputs)
	if (locale === "ru") return ru_delivery_board_waiting(inputs)
	if (locale === "pt") return pt_delivery_board_waiting(inputs)
	return ko_delivery_board_waiting(inputs)
});